export const ScheduleImmediatelySummary = () => (
  <>This campaign will be immediately available for eligible users to see.</>
);
